<div class="form-row" [formGroup]="formGroup">
    <div class="form-group col-md-4">
        <label for="codProv">Provincia*</label>
        <select class="form-control" formControlName="codProv" id="codProv" (change)="searchComuniByProvincia()">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option *ngFor="let item of datalist.province" [ngValue]="item.id">{{ item.descrizione }}</option>
        </select>
    </div>
    <div class="form-group col-md-4">
        <label id="labelComune" for="codIstat">Comune*</label>
        <input #inputComuni *ngIf="canEdit" type="text" class="form-control" id="codIstat" placeholder="Seleziona un'opzione..."
            formControlName="comune"
            [ngbTypeahead]="filterComuni"
            [inputFormatter]="comuneFormatter"
            [resultFormatter]="comuneFormatter"
            (selectItem)="selectItemComuni($event)"
            [editable]="false"
            />
        <input *ngIf="!canEdit" aria-labelledby="labelComune" type="text" class="form-control" id="comune" [disabled]="formGroup.controls['comune'].disabled" [value]="formGroup.controls['codIstat'].value | anagraficaComuni:(datalist.comuni || [])" />
    </div>
    <div class="form-group col-md-4">
        <label for="localita">Località</label>
        <input class="form-control" id="localita" formControlName="localita" type="text">
    </div>
    <div class="form-group col-md-4">
        <label for="bacinoIdrografico">Bacino idrografico</label>
        <input class="form-control" id="bacinoIdrografico" formControlName="bacinoIdrografico" type="text">
    </div>
    <div class="form-group col-md-4">
        <label for="sottoBacino">Sottobacino</label>
        <input class="form-control" id="sottoBacino" formControlName="sottoBacino" type="text">
    </div>
    <div class="form-group col-md-4">
        <label for="tipoShape">Tipo di geometria</label>
        <select class="form-control" formControlName="tipoShape" id="tipoShape">
            <!-- <option [ngValue]="null">Seleziona un'opzione...</option> -->
            <option *ngFor="let item of datalist.tipoShape" [ngValue]="item.id">{{ item.descrizione }}</option>
        </select>
    </div>
    <div class="form-group col-md-6">
        <label for="comunitaMontana">Comunità Montana</label>
        <input class="form-control" id="comunitaMontana" formControlName="comunitaMontana" type="text">
    </div>
    <div class="form-group col-md-6">
        <label for="consorzi">Consorzi</label>
        <input class="form-control" id="consorzi" formControlName="consorzi" type="text" [ngbTooltip]="getConsorzi()">
    </div>
    <div class="form-group col-md-12">
        <label for="trattoIdrico">Tratto idrico</label>
        <textarea class="form-control" id="trattoIdrico" formControlName="trattoIdrico"></textarea>
    </div>
    <div class="form-group col-md-6">
        <label for="classificazioneOpera">Categoria Opera*</label>
        <select class="form-control" formControlName="classificazioneOpera" id="classificazioneOpera" (change)="searchTipologiaOperaByClassificazioneOpera()">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option *ngFor="let item of datalist.classificazioneOpera" [ngValue]="item.id">{{ item.descrizione }}</option>
        </select>
    </div>

    <div class="form-group col-md-6">
        <label for="idTipologiaOpera">Tipologia opera*</label>
        <select class="form-control" formControlName="idTipologiaOpera" id="idTipologiaOpera" (change) ="setMacrotipologiaByTipologiaOpera()">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option *ngFor="let item of tipologiaOperaFiltered" [ngValue]="item.idTipologiaOpera">{{ item.descrizioneTipologiaOpera }}</option>
        </select>
    </div>

    <div class="form-group col-md-6">
        <label for="macroTipologiaOpera">Macrotipologia opera</label>
        <select class="form-control" formControlName="macroTipologiaOpera" id="macroTipologiaOpera" >
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option *ngFor="let item of datalist.macroTipologiaOpera" [ngValue]="item.id">{{ item.descrizione }}</option>
        </select>
    </div>

   
    <div class="form-group col-md-6">
        <label for="idFunzionePrevalente">Funzione prevalente</label>
        <select class="form-control" formControlName="idFunzionePrevalente" id="idFunzionePrevalente">
            <!-- <option [ngValue]="null">Seleziona un'opzione...</option> -->
            <option *ngFor="let item of datalist.funzionePrevalente" [ngValue]="item.id">{{ item.descrizione }}</option>
        </select>
    </div>
   
    <div class="form-group col-md-6">
        <label for="provenienza">Provenienza</label>
        <input class="form-control text-truncate" id="provenienza"  formControlName="provenienza" type="text" [ngbTooltip]="getProvenienza()">
        
    </div>

    
    <div class="form-group col-md-6">
        <label for="idImportanza">Importanza opera</label>
        <select class="form-control" formControlName="idImportanza" id="idImportanza">
            <option [ngValue]="null">Seleziona un'opzione...</option>
            <option *ngFor="let item of datalist.importanzaOpera" [ngValue]="item.id">{{ item.descrizione }}</option>
        </select>
    </div>
    <div class="form-group col-md-12">
        <label for="interventoEmergenza">Intervento in emergenza?</label>
        <div class="form-check form-check-inline">
            <input name="interventoEmergenza" type="radio" id="interventoEmergenza_si" formControlName="interventoEmergenza" [value]="true">
            <label for="interventoEmergenza_si">Si</label>
        </div>
        <div class="form-check form-check-inline">
            <input name="interventoEmergenza" type="radio" id="interventoEmergenza_no" formControlName="interventoEmergenza" [value]="false">
            <label for="interventoEmergenza_no">No</label>
        </div>
    </div> 
    <div class="form-group col-md-12">
        <label for="note">Note</label>
        <textarea class="form-control" id="note" formControlName="note" [value]="formGroup.get('note')?.value | specialCharacters"></textarea>
    </div>
</div>